import FundOpportunity from '../../models/FundOpportunity';
import Investor from '../../models/Investor';
import { FundOpportunityProps, FundOpportunityState } from './types';

export function buildInitialState(
  props: FundOpportunityProps,
  print: boolean | undefined,
  printDraft: boolean | undefined,
): FundOpportunityState {
  const modifiedProps = !props.tone ? { ...props, tone: 'default' as const } : props;

  let investor: Investor;
  let fundOpportunity: FundOpportunity;

  if (modifiedProps.investorId) {
    const foundInvestor = modifiedProps.investorContext?.investors?.find(
      (inv) => modifiedProps.investorId === inv.id,
    );
    if (!foundInvestor?.fundOpportunity) {
      throw new Error(`Investor not found for id ${modifiedProps.investorId}`);
    }
    investor = foundInvestor;
    fundOpportunity = foundInvestor.fundOpportunity;
  } else if (modifiedProps.fundOpportunity) {
    fundOpportunity = modifiedProps.fundOpportunity;
    if (modifiedProps.referrer) {
      investor = {
        id: 'referral-invite',
        contactId: 'referral-invite',
        fundOpportunityId: modifiedProps.fundOpportunity.id,
        status: 'LEAD',
        eoiSubmitted: false,
        updatedAt: new Date().toISOString(),
      };
    } else {
      investor = {
        id: 'fake',
        contactId: 'fake',
        fundOpportunityId: modifiedProps.fundOpportunity.id,
        status: 'LEAD',
        eoiSubmitted: true,
        eoiSubmittedOn: new Date('2025-01-01'),
        indicativeInvestment: print || printDraft ? undefined : 125000,
        updatedAt: '2025-01-01T15:31:31+11:00',
      };
    }
  } else {
    throw new Error('No investor or fund opportunity provided');
  }

  const hasToken = !!modifiedProps.prefetchedContent || !!modifiedProps.assetStorageToken;

  return {
    contentManagementInterface: modifiedProps.prefetchedContent || null,
    filter: 'All',
    loadingApplication: false,
    hasStorageToken: { tries: 0, tokenSet: hasToken },
    assetStorageToken: modifiedProps.assetStorageToken,
    printMode: !!print,
    pdfDraft: !!printDraft && !!print,
    withdrawEOI: false,
    editEOI: false,
    investor,
    fundOpportunity,
    staticPdfAvailable: false,
    loadingCustodianStatus: false,
    isCustodian: false,
  };
}
